import { Link } from "react-router-dom";
import { CARRIER_COORDINATION as T } from "@/constants/testIds";
import { Box } from "lucide-react";

export default function Navbar() {
  return (
    <header
      data-testid={T.navRoot}
      className="sticky top-0 z-40 w-full border-b border-slate-line bg-white/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10">
        <Link
          to="/carrier-coordination"
          data-testid={T.navLogo}
          className="group flex items-center gap-2.5"
        >
          <span
            className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-navy text-white shadow-card"
            style={{ backgroundColor: "hsl(var(--navy))" }}
          >
            <Box className="h-4 w-4" strokeWidth={2.4} />
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="text-[15px] font-semibold tracking-tight text-navy">DeMaxtore</span>
            <span className="hidden text-xs uppercase tracking-[0.14em] text-slate-500 sm:inline">
              Workspace
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <a href="#why-matters" className="text-sm text-slate-600 transition hover:text-navy">Why it matters</a>
          <a href="#how-it-works" className="text-sm text-slate-600 transition hover:text-navy">How it works</a>
          <a href="#workspace" className="text-sm text-slate-600 transition hover:text-navy">Workspace</a>
          <a href="#faq" className="text-sm text-slate-600 transition hover:text-navy">FAQ</a>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/freightiq"
            data-testid={T.navFreightIQ}
            className="hidden rounded-md px-3 py-2 text-sm font-medium text-slate-700 transition hover:text-navy sm:inline-flex"
          >
            FreightIQ™
          </Link>
          <Link
            to="/workspace"
            data-testid={T.navPrimaryCta}
            className="inline-flex items-center gap-1.5 rounded-full bg-navy px-4 py-2 text-sm font-medium text-white shadow-card transition hover:translate-y-[-1px] hover:shadow-card-lg"
            style={{ backgroundColor: "hsl(var(--navy))" }}
          >
            Create Workspace
            <span aria-hidden>→</span>
          </Link>
        </div>
      </div>
    </header>
  );
}
